module.exports = __webpack_public_path__ + "static/CrimsonText-Regular-100aa30a798f97d336e4983e3a8878b0.woff";